<template>
    <modal name="embed-token">
        <div class="p-4 d-flex justify-content-between h-100 flex-column">
            <div class="p-4 d-flex justify-content-between h-100 flex-column">
                <code>{{ embedToken }}</code>
            </div>

            <div class="d-flex">
                <button
                    class="btn btn-secondary mr-3"
                    @click="$modal.hide('embed-token')"
                >
                    <span>Close</span>
                </button>

                <button
                    class="btn btn-primary"
                    @click="copy"
                >
                    <span>Copy to clipboard</span>
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: 'EmbedTokenModal',

    props: {
        embedToken: {
            type: String,
            required: true,
        },
    },

    methods: {
        copy() {
            this.$clipboard(this.embedToken);
            this.$modal.hide('embed-token');
            this.$toastr.s('Copied!');
        },
    },
};
</script>

<style scoped>

</style>
